// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import { ActionTypes } from "../actions/actionTypes";
import { AnyAction } from "../actions/actionCreators";
import { IQueues } from "../../models/applicationState";

/**
 * App Title Reducer
 * Actions handled:
 *  SET_TITLE
 * @param {string} state
 * @param {AnyAction} action
 * @returns {any}
 */
export const reducer = (state: IQueues[] = [], action: AnyAction): IQueues[] => {
    switch (action.type) {
        case ActionTypes.LOAD_USER_ALL_QUEUE_SUCCESS:
            return action.payload;
        // case ActionTypes.DELETE_USER_QUEUE_SUCCESS:
        //     const updatedState = state.filter((model) => model.model_id !== action.payload.model_id);
        //     return [...state.filter((model) => model.model_id !== action.payload.model_id)];
      //  return [];
        case ActionTypes.LOGGED_OUT_USER:
            return [];
        default:
            return state;
    }
};
